import {
	PersonCard,
	type PersonCardImage,
} from '#app/components/person-card.tsx'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/team.ts'

type PersonEntry = {
	_key: string
	name?: string
	profilePic?: PersonCardImage
	bio?: string
}

const profilePicFragment = `
	profilePic {
		...,
		asset-> {
			_id,
			metadata {
				dimensions { width, height, aspectRatio }
			}
		}
	}
`

export async function loader() {
	const team = await safeFetch<PersonEntry[] | null>(
		`*[_type == "aboutPage"][0].team[] { _key, name, bio, ${profilePicFragment} }`,
	)
	return { team }
}

export default function TeamTab({ loaderData }: Route.ComponentProps) {
	const { team } = loaderData

	if (!team || team.length === 0) {
		return (
			<p className="text-muted-foreground px-4 text-center">
				No team members listed yet.
			</p>
		)
	}

	return (
		<div className="mx-auto max-w-5xl px-4">
			<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
				{team.map((person) => (
					<PersonCard
						key={person._key}
						name={person.name ?? ''}
						profilePic={person.profilePic}
						bio={person.bio}
					/>
				))}
			</div>
		</div>
	)
}
